import { fadeIn, fadeInUp } from "react-animations";
import styled, { keyframes } from "styled-components";
import colors from "../../../../assets/styles/colors";

const fadeInAnimation = keyframes`${fadeIn}`;
const fadeInUpAnimation = keyframes`${fadeInUp}`;

export const Div = styled.div``;

export const Row = styled.div``;

export const Col = styled.div``;

export const Container = styled.div`
  animation: 1s ${fadeInAnimation};
`;

export const LogoContainer = styled.div`
  box-shadow: 0 0 2px 2px
    ${(props) => (props.theme?.isDarkTheme ? "#2d2d2d" : "#f9f9f9")};
  border: 1px solid
    ${(props) => (props.theme?.isDarkTheme ? "#737373" : "#eaeaea")};
  border-radius: 15px;
  padding: 1px;
`;

export const Logo = styled.img``;

export const Title = styled.div`
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? colors.textColorBlackSeven
      : colors.textColorBlackSix};
  ${(props) => props.fieled && `color: ${colors.colorRed};`}
`;

export const ItemData = styled.span`
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? colors.textColorBlackNine
      : colors.textColorBlackOne};
`;

export const BorderLine = styled.span`
  border-bottom: 3px solid
    ${(props) =>
      props.selected ? colors.colorGreen : colors.textColorBlackSeven};
  ${(props) => props.fieled && `border-color: ${colors.colorRed};`}

  width: 39%;
  transition: 1s;

  @media screen and (max-width: 524px) {
    width: 39%;
  }

  @media screen and (max-width: 496px) {
    width: 37%;
  }

  @media screen and (max-width: 422px) {
    width: 35%;
  }

  @media screen and (max-width: 369px) {
    width: 33%;
  }

  @media screen and (max-width: 328px) {
    width: 31%;
  }

  @media screen and (max-width: 296px) {
    width: 29%;
  }

  @media screen and (max-width: 270px) {
    width: 27%;
  }
`;

export const Icon = styled.i`
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? colors.textColorBlackNine
      : colors.textColorBlackFive};
`;

export const IconLine = styled.i`
  color: ${(props) =>
    props.selected
      ? colors.colorGreen
      : props.theme?.isDarkTheme
      ? colors.textColorBlackNine
      : colors.textColorBlackSeven}};

      ${(props) => props.fieled && `color: ${colors.colorRed};`}
`;

export const Timer = styled.span`
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? colors.textColorBlackNine
      : colors.textColorBlackSix};
`;

export const OrderStatus = styled.div`
  animation: 1s ${fadeInUpAnimation};
`;
